import PropTypes from 'prop-types'
import React from 'react'
import { getContrastingColor } from 'react-color/lib/helpers'

const ViewTagsCell = ({ tags }) => {
  if (!tags?.length) return null
  return (
    <div className='flex gap-2'>
      {tags.map(tag => (
        <div
          key={tag.tagId}
          className='rounded text-center text-bold'
          style={{
            backgroundColor: tag.color || '#E0E0E0',
            padding: '2px 6px',
            color: getContrastingColor(tag.color || '#E0E0E0')
          }}
        >
          {tag.displayName || tag.name}
        </div>
      ))}
    </div>
  )
}

ViewTagsCell.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    description: PropTypes.string,
    tagId: PropTypes.number,
    color: PropTypes.string
  }))
}

export default ViewTagsCell
